import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeFilter } from "../../features/filter/filterSlice";

function Filter() {
  const dispatch = useDispatch();
  const filterState = useSelector((state) => state.filter);

  function handleFilterChange(event) {
    dispatch(changeFilter(event.target.value));
  }

  return (
    <div className="sidebar-content">
      <h4>Filter</h4>
      <div className="radio-group">
        <div>
          <input
            type="radio"
            name="filter"
            id="lws-all"
            checked={filterState.filterMode === "all"}
            className="radio"
            value="all"
            onChange={handleFilterChange}
          />
          <label htmlFor="lws-all">All</label>
        </div>
        <div>
          <input
            type="radio"
            name="filter"
            id="lws-saved"
            className="radio"
            checked={filterState.filterMode === "saved"}
            value="saved"
            onChange={handleFilterChange}
          />
          <label htmlFor="lws-saved">Saved</label>
        </div>
      </div>
    </div>
  );
}

export default Filter;
